// extracted by mini-css-extract-plugin
module.exports = {"Buttons":"Slider_Buttons__3OEdc","Button":"Slider_Button__3gnbX"};